export const emailRegexp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
